module.exports = __webpack_public_path__ + "img/medal-silver.051980f3.png";